import LoaderMain from 'components/shared/LoaderMain';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useLocation } from 'react-router-dom';

const DetailsPackageSkeleton: FC = () => {
  const { pathname } = useLocation();
  const getRandom = (min: number, max: number) => {
    return Math.random() * (max - min) + min;
  };
  return (
  <>
      <div className="details package-details">
        <div className="default-shadow flight-details-item">
          <div className="title-underline text-lg mb-15">
            <Skeleton width={150} height={26} />
          </div>
          <div className="flight-details-info">
            {[...Array(11)].map((_, index) => (
              <div className="package-details-block" key={index}>
                <span className="package-details-title">
                  <Skeleton height={16} width={getRandom(60, 150)} />
                </span>
                <span className="package-details-text">
                  <Skeleton height={16} width={getRandom(70, 190)} />
                </span>
              </div>
            ))}
          </div>
        </div>

        {[...Array(2)].map((_, index) => (
          <div
            className="default-shadow flight-details-item flight-details-ticket package-ticket"
            key={index}
          >
            <div className="flex-between ticket-header">
              <Skeleton width={140} height={16} />
            </div>
            <div className="ticket-details-info">
              <div className="item">
                <span className="city text-bold">
                  <Skeleton height={19} width={30} />
                </span>
                <span className="time text-bold">
                  <Skeleton height={23.8} width={55} />
                </span>
                <span className="day">
                  <Skeleton height={17.4} width={50} />
                </span>
              </div>
              <div className="item">
                <span className="city text-bold">
                  <Skeleton height={19} width={30} />
                </span>
                <span className="time text-bold">
                  <Skeleton height={23.8} width={55} />
                </span>
                <span className="day">
                  <Skeleton height={17.4} width={100} />
                </span>
              </div>
              <div className="item">
                <span className="flex-center">
                  <Skeleton height={60} width={82} />
                </span>
              </div>
              <div className="item">
                <Skeleton height={16} width={16} />
                <span className="time text-bold">
                  <Skeleton height={24} width={54} />
                </span>
              </div>
            </div>
            <div className="text-sm">
              <span>
                <Skeleton height={17} width={320} />
              </span>
            </div>
          </div>
        ))}

        {[...Array(2)].map((_, index) => (
          <div className="default-shadow flight-details-item " key={index}>
            <Skeleton width={140} height={16} className="mb-5" />
            <Skeleton width={230} height={16} className="mb-20" />
            <Skeleton width={140} height={16} className="mb-5" />
            <Skeleton width={'30%'} height={16} className="mb-5" />
            <Skeleton width={'95%'} height={16} className="mb-5" />
            <Skeleton width={'92%'} height={16} className="mb-5" />
            <Skeleton width={'70%'} height={16} className="mb-20" />
            <Skeleton width={150} height={16} className="mb-5" />
            <Skeleton width={'50%'} height={16} />
          </div>
        ))}
      </div>
      <div className="package-summary">
        <div className="default-shadow package-summary-map">
          <Skeleton width={'100%'} height={'100%'} />
        </div>
        <div className="default-shadow flight-details-item">
          <div className="title-underline text-st mb-20">
            <Skeleton width={'80%'} height={22.5} />
          </div>
          {[...Array(3)].map((_, index) => (
            <div key={index} className="package-summary-suggestion">
              <div className="suggestion-img ">
                <Skeleton width={'100%'} height={60} />
              </div>
              <div className="ml-10">
                <div className="title text-sm text-cap text-contrast mb-5">
                  <Skeleton height={14.4} width={getRandom(100, 170)} />
                </div>
                <div className="mb-5">
                  <span className="text-sm text-bold text-contrast mr-5">
                    <Skeleton height={17} width={120} />
                  </span>
                  <span className="text-xsm">
                    <Skeleton height={15} width={80} />
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <LoaderMain
        systemProducts={pathname.includes('tour') ? 'Tours' : 'Nofshon'}
        systemProductsDetails="LoadingDetails"
      />
  </>
  );
};

export default DetailsPackageSkeleton;
